export class EventBuilder {
    public getParams<T>(...args: any) {
        return {};
    }
}
